import React from 'react'
import './index.less'
import {ManageFeatureDescriptionItem} from "../ManageFeatureDescriptionItem";

const clsPrefix = 'cy-manage-card'
const ManageFeatureCard: React.FC<{
  title: string[],
  descriptions: string[],
  iconStyle?: React.CSSProperties
}> = ({
  title = [],
  descriptions = [],
  iconStyle = [ { border: '#3765FF'  },{ border: '#FC4D5A' },{ border: '#9A43FB' },{ border: '#FEB900' }]

}) => {
  return (
    <div className={`${clsPrefix}`}>
      {/*<img src={imgUrl} className={`${clsPrefix}__image hover-grow`} alt='' />*/}
      <div className={`${clsPrefix}__content`}>
        <div className={`${clsPrefix}__title`}>
          <div className={`${clsPrefix}__title-inner`}>
            {
              title && title.map((text,index) => (
                <p key={index}>{text}</p>
              ))
            }
            <hr className={`${clsPrefix}__title-line`} />
          </div>
        </div>
        <div className={`${clsPrefix}__descriptions`}>
          {
            descriptions && descriptions.map(((item, index) => (
              <ManageFeatureDescriptionItem
                key={index} content={item}
                className='mgf-desc'
                iconName='raw-right'
                iconStyle={iconStyle[index]}
                iconClassName='desc-icon'
              />
            )))
          }
        </div>
      </div>
    </div>
  )
}

export { ManageFeatureCard }
